import { crudMdActions } from "@/services/crud-md-actions";

const name = "devices";

export default {
  name,
  ...crudMdActions(name),
};
